class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  initRechargeWidgets() {
      console.log("Recharge widgets re-initialized in CartDrawerItems.");
      const points = document.querySelectorAll('.rc-custom-injection-point');
      if (!points.length) return;

      if (!window.ReChargeWidget || typeof window.ReChargeWidget.createWidget !== 'function') {
        console.warn("Recharge widget not ready yet.");
        return;
      }

      points.forEach(el => {
        const productId = el.getAttribute('data-product-id');
        if (!productId || el.dataset.rcInjected === 'true') return;

        window.ReChargeWidget.createWidget({
          productId,
          injectionParent: `.rc-custom-injection-point[data-product-id="${productId}"]`,
          injectionMethod: 'append',
          selectors: {
            price: ['.cart-item__price'],
            variant: ['.cart-item__variant']
          }
        });

        el.dataset.rcInjected = 'true'; // prevent duplicates
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        console.log("cart drawer opened");

        this.initRechargeWidgets();

        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    document.dispatchEvent(new CustomEvent('cart:sections-rendered', { detail: parsedState }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('DOMContentLoaded', () => {

  const termsCheckbox = document.getElementById('terms-checkbox');
  const checkoutBtn = document.querySelector('.cart__checkout-button');

  // Enable checkout only if terms are accepted
  if (termsCheckbox && checkoutBtn) {
    termsCheckbox.addEventListener('change', () => {
      checkoutBtn.disabled = !termsCheckbox.checked;
      const discountError = document.getElementById('discount-error');
      if (discountError) discountError.style.display = 'none';
    });
  }

  // Discount code handling (event delegation on cart-drawer so it survives section re-renders)
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    let messageTimeout = null;
    const MESSAGE_TIMEOUT = 3000;
    const ERROR_MESSAGES = {
      empty: 'Please enter a promo code.',
      invalid: 'Please enter a valid discount code.'
    };

    const showMessage = (errorMessageEl, message, isError = true) => {
      if (!errorMessageEl) return;
      if (messageTimeout) clearTimeout(messageTimeout);
      errorMessageEl.textContent = message;
      errorMessageEl.style.color = isError ? 'red' : 'green';
      errorMessageEl.style.display = 'block';
      messageTimeout = setTimeout(() => {
        errorMessageEl.style.display = 'none';
        errorMessageEl.textContent = '';
        messageTimeout = null;
      }, MESSAGE_TIMEOUT);
    };

    const clearMessage = (errorMessageEl) => {
      if (messageTimeout) {
        clearTimeout(messageTimeout);
        messageTimeout = null;
      }
      if (errorMessageEl) {
        errorMessageEl.style.display = 'none';
        errorMessageEl.textContent = '';
      }
    };

    const setButtonState = (btn, disabled, text) => {
      if (!btn) return;
      btn.disabled = disabled;
      btn.textContent = text;
    };

    const getSectionsToRender = () => {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (!cartDrawerItems) return 'cart-drawer,cart-icon-bubble';
      return cartDrawerItems.getSectionsToRender()
        .map(section => section.section)
        .join(',');
    };

    const updateCartSections = (sections, cartDrawerItems) => {
      if (!sections || !cartDrawerItems) return;
      cartDrawerItems.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector)
          || document.getElementById(section.id);
        if (elementToReplace && sections[section.section]) {
          elementToReplace.innerHTML = cartDrawerItems.getSectionInnerHTML(
            sections[section.section],
            section.selector
          );
        }
      });
    };

    const isDiscountValid = (response, data) => {
      if (!response.ok || data.errors) return false;
      const hasInvalidDiscount = data.discount_codes?.some(
        discount => discount.applicable === false
      );
      return !hasInvalidDiscount;
    };

    const refreshCartAfterDiscount = (data) => {
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      updateCartSections(data.sections, cartDrawerItems);

      if (data.item_count !== undefined) {
        updateCartItemCount(data);
        updateFreeShippingBar(data);
      }

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data } }));
    };

    // Handle apply discount button
    cartDrawer.addEventListener('click', async (event) => {
      if (event.target.id !== 'apply-discount') return;
      const discountInput = document.getElementById('discount-code');
      const errorMessage = document.getElementById('discount-error');
      const applyDiscountBtn = event.target;
      if (!discountInput || !errorMessage) return;

      const originalButtonText = applyDiscountBtn.textContent;
      const code = discountInput.value.trim();
      clearMessage(errorMessage);

      if (!code) {
        showMessage(errorMessage, ERROR_MESSAGES.empty, true);
        return;
      }

      setButtonState(applyDiscountBtn, true, 'Applying...');

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: code, sections: getSectionsToRender() })
        });

        const data = await response.json();

        if (isDiscountValid(response, data)) {
          showMessage(errorMessage, 'Discount code applied successfully!', false);
          discountInput.value = '';
          refreshCartAfterDiscount(data);
        } else {
          showMessage(errorMessage, ERROR_MESSAGES.invalid, true);
        }
      } catch (error) {
        showMessage(errorMessage, ERROR_MESSAGES.invalid, true);
        console.error('Error applying discount:', error);
      } finally {
        setButtonState(applyDiscountBtn, false, originalButtonText);
      }
    });

    // Handle remove discount (X button on applied discount tags)
    cartDrawer.addEventListener('click', async (event) => {
      const removeBtn = event.target.closest('.discount-tag__remove');
      if (!removeBtn) return;

      const li = removeBtn.closest('.discounts__discount');
      if (li) li.style.opacity = '0.5';

      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ discount: '', sections: getSectionsToRender() })
        });
        const data = await response.json();
        refreshCartAfterDiscount(data);
      } catch (error) {
        console.error('Error removing discount:', error);
        if (li) li.style.opacity = '1';
      }
    });
  }

  // Update cart item count in title
  function updateCartItemCount(cart) {
    const titleEl = document.querySelector('.cart-drawer__title');
    if (titleEl) {
      titleEl.textContent = `YOUR CART (${cart.item_count})`;
    }
  }

  // Helper function to format money from cents
  function formatMoney(cents, currencyCode = 'USD') {
    const amount = (cents / 100).toFixed(2);
    const currencySymbols = {
      'USD': '$',
      'EUR': '€',
      'GBP': '£',
      'CAD': 'C$',
      'AUD': 'A$',
      'JPY': '¥'
    };
    const symbol = currencySymbols[currencyCode] || '$';
    return `${symbol}${amount}`;
  }

  // Update free shipping progress bar
  function updateFreeShippingBar(cart) {
    const barFill = document.querySelector('.progress-bar__fill');
    const messageEl = document.querySelector('.cart-drawer__free-shipping p');
    const freeShippingEl = document.querySelector('.cart-drawer__free-shipping');
    const progressBarEl = document.querySelector('.progress-bar');

    if (!barFill || !messageEl || !freeShippingEl) return;

    const configuredThreshold = parseInt(freeShippingEl.dataset.freeShippingThreshold || '5899', 10);
    const freeShippingThreshold = Number.isFinite(configuredThreshold) && configuredThreshold > 0
      ? configuredThreshold
      : 5899;

    const parseProductIds = (raw) => (raw || '').split(',').map(s => s.trim()).filter(Boolean).map(Number);
    const excludedProductIds = parseProductIds(freeShippingEl.dataset.excludedProductIds);
    const soloProductIds = parseProductIds(freeShippingEl.dataset.soloProductIds);
    const promoProductIds = parseProductIds(freeShippingEl.dataset.promoProductIds);

    const cartItems = cart.items || [];
    const hasExcludedItem = cartItems.some(item => excludedProductIds.includes(item.product_id));
    const hasPromotionItem = cartItems.some(item => promoProductIds.includes(item.product_id));
    const allItemsInSoloCollection = cartItems.length > 0
      && cartItems.every(item => soloProductIds.includes(item.product_id));

    const cartTotal = cart.total_price;
    const freeShippingGranted = hasPromotionItem || allItemsInSoloCollection || cartTotal >= freeShippingThreshold;

    // A promotion item always grants free shipping and suppresses the ineligible message
    if (hasExcludedItem && !hasPromotionItem) {
      const ineligibleMessage = freeShippingEl.dataset.ineligibleMessage || 'Some items in your cart are not eligible for free shipping.';
      messageEl.textContent = ineligibleMessage;
      if (progressBarEl) progressBarEl.style.display = 'none';
      freeShippingEl.classList.add('excluded-shipping');
      return;
    }

    freeShippingEl.classList.remove('excluded-shipping');
    if (progressBarEl) progressBarEl.style.display = '';

    const currencyCode = (cart.currency && cart.currency.iso_code) ? cart.currency.iso_code : 'USD';
    let progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

    if (freeShippingGranted) {
      messageEl.textContent = "You've got FREE shipping! (Contiguous U.S. Only)";
      progress = 100;
    } else {
      const remaining = freeShippingThreshold - cartTotal;
      messageEl.textContent = `Spend ${formatMoney(remaining, currencyCode)} more for FREE shipping (Contiguous U.S. Only)`;
    }

    barFill.style.width = `${progress}%`;
  }

  // Listen for Dawn's cart update event
  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail.cart;
    updateCartItemCount(cart);
    updateFreeShippingBar(cart);
  });

  // Initial fetch to set values on page load
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartItemCount(cart);
      updateFreeShippingBar(cart);
    });

});
